<script setup lang="ts">
import { appStore } from "@/stores/app-store";
import { ref, watch } from "vue";
import { defineProps } from "vue";

const props = defineProps({
  show: Boolean
});

// eslint-disable-next-line
const emit = defineEmits(['close','filter'])

const store = appStore();
let floorplan = ref(store.floorplanFilter);
let status = ref(store.statusFilter);
let availableSizes = new Set<number>();
let availablePrices = new Set<number>();

store.unitsData.forEach(element => {
  availableSizes.add(element.minSqft);
  availableSizes.add(element.maxSqft);
  availablePrices.add(element.startingPrice);
});

let priceArray: number[] = Array.from(availablePrices.values());
priceArray.sort();

let sizesArray: number[] = Array.from(availableSizes.values());
sizesArray.sort();

function applyFilter(){
  store.floorplanFilter = floorplan.value;
  store.statusFilter = status.value;

  emit('close');
  emit('filter');
}
function resetFilter(){
  floorplan.value = '';
  emit('close');
}

watch(
  () => store.floorplanFilter,
  (newVal, oldVal) => {
    floorplan.value = newVal;
  }
)
watch(
  () => store.statusFilter,
  (newVal, oldVal) => {
    status.value = newVal;
  }
)
</script>

<template>
  <Transition name="modal">
    <div v-if="show" class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="floorplanFilterPanel">
                <div class="filterElem">FILTER BY FLOORPLAN:</div>
                <div class="filterElem">
                    <input type="radio" id="showAll" value="" v-model="floorplan" />
                    <label for="showAll">SHOW ALL</label>
                </div>
                <div class="filterElem">
                    <input type="radio" id="theAustin" value="The Austin" v-model="floorplan" />
                    <label for="theAustin">THE AUSTIN</label>
                </div>
                <div class="filterElem">
                    <input type="radio" id="theBrookline" value="The Brookline" v-model="floorplan" />
                    <label for="theBrookline">THE BROOKLINE</label>
                </div>
                <div class="filterElem">
                    <input type="radio" id="theCarmel" value="The Carmel" v-model="floorplan" />
                    <label for="theCarmel">THE CARMEL</label>
                </div>
                <div class="filterElem">
                    <input type="radio" id="theDurham" value="The Durham" v-model="floorplan" />
                    <label for="theDurham">THE DURHAM</label>
                </div>
                <div class="filterElem">
                    <input type="radio" id="theEvanston" value="The Evanston" v-model="floorplan" />
                    <label for="theEvanston">THE EVANSTON</label>
                </div>
              </div>
              <div class="statusFilterPanel">
                <div class="filterElem">FILTER BY STATUS:</div>
                <div class="filterElem">
                    <input type="radio" id="all" value="" v-model="status" />
                    <label for="all">ALL</label>
                </div>
                <div class="filterElem">
                    <input type="radio" id="available" value="Available" v-model="status" />
                    <label for="available">AVAILABLE</label>
                </div>
                <div class="filterElem">
                    <input type="radio" id="comingSoon" value="ComingSoon" v-model="status" />
                    <label for="comingSoon">COMING SOON</label>
                </div>
                <div class="filterElem">
                    <input type="radio" id="sold" value="Sold" v-model="status" />
                    <label for="sold">SOLD</label>
                </div>
              </div>
            </div>
            <div class="buttonPanel">
              <button class="formButton" @click="applyFilter">APPLY</button>
              <button class="formButton" @click="resetFilter">CANCEL</button>
            </div>
          </div>  
        </div>
      </div>
    </div>
  </Transition>
</template>

<style lang="scss" scoped>
.filterElem{
  padding-bottom: 10px;
}
.inputForm{
  padding-top: 2px;
  display: flex;
}
input:disabled {
  /* disabled styling goes here */
  background-color: white;
  color: black;
  border: solid 1px black;
}
.selectInput{
  width: 240px;
  height: 30px;
  margin-top: 2px;
  border: solid 1px black;
}
.baseInput{
  width: 180px;
  height: 26px;
}
.shortInput{
  width: 90px;
}
.inputButton{
  border: none;
  color: white;
  font-weight: bold;
  font-size: large;
  height: 30px;
  width: 30px;
  background-size: contain;
}
.formButton{
    width: 100px;
    height: 40px;
    color: white;
    background-color: #032F3A;
    border: none;
    font-family: Brandon Groeteque Bold;
    margin-right: 25px;
    font-size: large;
}
.column {
  float: left;
}
.spacer{
  float: left;
  width: 150px;
}
.buttonPanel{
  padding-top: 5px;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
  font-family: Brandon Groeteque Bold;
  font-size: larger;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 250px;
  margin: 0px auto;
  padding: 10px 30px;
  background-color: #e1e9ed;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  color: #032F3A;
  max-height: 90vh;
  overflow: auto;
}

.modal-header {
  margin-top: 15px;
}

.modal-body {
  box-sizing: border-box;
  font-size: large;
  font-family: Brandon Groeteque Bold;
  select, input{
    font-size: large;
    font-family: Brandon Groeteque Bold;
    color: #767676;
  }
}

.modal-close-button {
  float: right;
  position: relative;
  top: -2px;
  right: -25px;
  background-color: #D9D9D9;
  border: none;
  background-image: url('./../assets/close-icon.png');
  background-size: contain;
  width: 40px;
  height: 40px;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter-from {
  opacity: 0;
}

.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>